import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(menuItemsSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(menuItemsFlow);

import { put, call, take } from 'redux-saga/effects';
import * as actions from './actions';
import { menuItemsRequest } from './api';
import { MENU_ITEMS_REQUEST } from './constants';

export function menuItemsSaga(apiUrl) {
  var response;
  return _regeneratorRuntime.wrap(function menuItemsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.loading());

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return call(menuItemsRequest, apiUrl);

        case 5:
          response = _context.sent;
          _context.next = 8;
          return put(actions.success(response));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context['catch'](2);
          _context.next = 14;
          return put(actions.failure(_context.t0));

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[2, 10]]);
}

export function menuItemsFlow() {
  var _ref, apiUrl;

  return _regeneratorRuntime.wrap(function menuItemsFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return put(actions.notAsked());

        case 2:
          if (!true) {
            _context2.next = 11;
            break;
          }

          _context2.next = 5;
          return take(MENU_ITEMS_REQUEST);

        case 5:
          _ref = _context2.sent;
          apiUrl = _ref.apiUrl;
          _context2.next = 9;
          return call(menuItemsSaga, apiUrl);

        case 9:
          _context2.next = 2;
          break;

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export default menuItemsFlow;